/* Galerie & Kunsthaus Nottbohm — Klick auf Bilder im „Banner mit Karussell“
   Die Bilder können im Editor einen Link bekommen (Block-Einstellung „Link“).
   Das Karussell des Themes fängt Mausklicks für das Ziehen ab, der Klick
   landet dann auf dem Karussellbereich statt auf dem Bild. Hier wird der
   Klick dem Bild unter dem Mauszeiger zugeordnet — aber nur, wenn nicht
   gezogen wurde. Nicht Teil des Impression-Themes.
*/
(function () {
	"use strict";

	var SCHWELLE = 8;

	function verbinden(bereich) {
		if (bereich.getAttribute("data-nb-links")) return;
		bereich.setAttribute("data-nb-links", "1");
		var start = null;

		bereich.addEventListener("pointerdown", function (e) {
			start = { x: e.clientX, y: e.clientY };
		}, true);

		bereich.addEventListener("click", function (e) {
			var direkt = e.target.closest && e.target.closest(".nb-slide-link");
			if (direkt && !e.defaultPrevented) return;
			if (start && Math.abs(e.clientX - start.x) + Math.abs(e.clientY - start.y) > SCHWELLE) return;
			var links = bereich.querySelectorAll(".nb-slide-link");
			for (var i = 0; i < links.length; i++) {
				var r = links[i].getBoundingClientRect();
				if (!r.width) continue;
				if (e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom) {
					e.preventDefault();
					window.location.href = links[i].href;
					return;
				}
			}
		});
	}

	function start() {
		var bereiche = document.querySelectorAll(".js-banner-with-carousel-custom-cursor-area");
		Array.prototype.forEach.call(bereiche, function (b) {
			if (b.querySelector(".nb-slide-link")) verbinden(b);
		});
	}

	if (document.readyState === "loading") {
		document.addEventListener("DOMContentLoaded", start);
	} else {
		start();
	}
	document.addEventListener("shopify:section:load", start);
})();
